import React, { useEffect, useState } from "react";
import { Button, DatePicker, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL, decklogdownloadPdfUrl } from "../../../services/apiConstants";
import VoyageDetails from "../../../components/VoyageDetails";
import { formatDate } from "../../../utils/dateFormatter";
import useVoyageList from "../../../hooks/useVoyageList";
import { DOWNLOADPDF } from "../../../utils/downloadPdf";
import dayjs from "dayjs";
import { dateRanges } from "../../../Data/data";
import { EyeOutlined } from "@ant-design/icons";

const NotificationList = () => {
  const navigate = useNavigate();
  const { voyageList } = useVoyageList();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [voyage_ids, set_voyage_id] = useState("");
  const [voyage_status, set_voyage_status] = useState(true);
  const [selectedDates, setSelectedDates] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { RangePicker } = DatePicker;
  const [designation, setDesignation] = useState("");
  const handleDateChange = (dates) => setSelectedDates(dates);

  useEffect(() => {
    if (voyageList?.length > 0) {
      const runningVoyage = voyageList.find(
        (voyage) => voyage.voyage_status === true
      );
      set_voyage_status(runningVoyage?.voyage_status);
      if (runningVoyage) {
        set_voyage_id(runningVoyage.id);
        if (runningVoyage.id) LIST_NOTIFICATIONS_API(runningVoyage.id);
      }
    }
  }, [voyageList]);

  useEffect(() => {
    if (selectedDates?.length === 2) {
      const format = (date) => new Date(date).toISOString().split("T")[0];
      setStartDate(format(selectedDates[0]));
      setEndDate(format(selectedDates[1]));
    }
  }, [selectedDates]);

  const LIST_NOTIFICATIONS_API = (voyage_id) => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", voyage_id);
      post(ApiURL.list_notifications, FORM_DATA).then((res) => {
        if (res?.status === true) {
          setFilteredData(res.data || []);
        }
        set_page_loader(false);
      });
    } catch (error) {
      console.error("Error fetching notification list:", error);
      set_page_loader(false);
    }
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const user_data = localStorage.getItem("user_data");
    const parsedData = JSON.parse(staff_dashboards);
    const parsed_User_Data = JSON.parse(user_data);
    set_staff_dashboard(parsedData);
    setDesignation(parsed_User_Data?.data?.designation);
    if (voyage_ids) LIST_NOTIFICATIONS_API(voyage_ids);
  }, []);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      align: "center",
    },
    {
      title: "Message",
      dataIndex: "description",
      key: "description",
      align: "center",
      width: "30%",
      render: (text) => (
        <Tooltip title={text}>
          <span>
            {text?.length > 50 ? `${text.substring(0, 50)}...` : text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (text) => formatDate(text),
    },
    {
      title: "Requsted By",
      dataIndex: "staff_name",
      key: "staff_name",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Button
          disabled={!voyage_status}
          type="primary"
          size="small"
          onClick={() => {
            const recordId = btoa(record?.record_id);
            const garbage_id = btoa(record?.record_id);
            const ballast_id = btoa(record?.record_id);

            let urls = [];
            let selectedKeys = [];
            const notificationType = record?.type;
            const description = record?.description || "";

            if (notificationType === "refrigeration" || description.includes("Refrigeration")) {
              urls.push(`/view-refrigeration-equip-log/${record?.record_id}`);
              selectedKeys.push("ods_refrigeration");
            } else if (notificationType === "supply_discharge" || description.includes("Supply and Discharge")) {
              urls.push(`/view-supply-and-discharge-log/${record?.record_id}`);
              selectedKeys.push("ods_supply_discharge");
            } else {
              switch (designation) {
                case "Chief Engineer":
                  urls.push(`/edit-oil-record-log-one/${recordId}`);
                  selectedKeys.push("12");
                  break;

                case "Chief Officer":
                  urls.push(`/edit-oil-record-log/${recordId}`);
                  selectedKeys.push("13");
                  break;

                case "Captain":
                  if (record?.orb_part == 1) {
                    urls.push(`/edit-oil-record-log-one/${recordId}`);
                    selectedKeys.push("12");
                  }

                  if (record?.orb_part == 2) {
                    urls.push(`/edit-oil-record-log/${recordId}`);
                    selectedKeys.push("13");
                  }

                  if (record?.grb_part == 1) {
                    urls.push(`/edit-garbage-log/${garbage_id}`);
                    selectedKeys.push("10");
                  }

                  if (record?.grb_part == 2) {
                    urls.push(`/edit-garbage-log-two/${garbage_id}`);
                    selectedKeys.push("11");
                  }

                  if (record?.ballast == 1) {
                    urls.push(`/edit-ballast-record/${ballast_id}`);
                    selectedKeys.push("14");
                  }
                  if (record?.cargo == 1) {
                    urls.push(`/edit-cargo-record/${ballast_id}`);
                    selectedKeys.push("9");
                  }

                  break;

                default:
                  break;
              }
            }

            if (urls.length) {
              localStorage.setItem("selectedKey", selectedKeys[0]);
              window.location.href = urls[0]; // ✅ same window navigation
            }
          }}
        >
          <EyeOutlined />
        </Button>
      ),
    },
  ];

  return (
    <>
      <VoyageDetails
        staff_dashboard={staff_dashboard?.voyage_details}
        buttonShow={false}
        disabled={!voyage_status}
        buttonProps={{
          text: "",
          className: "",
        }}
      />

      <div className="row">
        <div
          className="col-3"
          style={{ marginBottom: "13px", marginLeft: "15px" }}
        >
          <label className="block-label">Select Voyage Id</label>
          <Select
            placeholder="---- Select Voyage Id ----"
            style={{ width: "100%" }}
            value={voyage_ids}
            onChange={(value) => {
              const selectedVoyage = voyageList.find(
                (voyage) => voyage.id === value
              );
              if (selectedVoyage) {
                set_voyage_status(selectedVoyage.voyage_status);
              }
              set_voyage_id(value);
              LIST_NOTIFICATIONS_API(value);
            }}
          >
            {voyageList?.map((voyage) => (
              <Select.Option key={voyage.id} value={voyage.id}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{`Voyage Id: ${voyage.id}`}</span>
                  <span
                    style={{
                      color:
                        voyage.voyage_status === true ? "#FFA500" : "#008000",
                      fontWeight: "550",
                      marginRight: "15px",
                    }}
                  >
                    {voyage.voyage_status === true ? "Running" : "Complete"}
                  </span>
                </div>
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="col-3"></div>
        <div
          className="col-6"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div style={{ marginRight: "15px" }}>
            <label className="block-label">Select Start Date & End Date</label>
            <RangePicker
              presets={dateRanges}
              onChange={handleDateChange}
              value={
                selectedDates && selectedDates.length
                  ? [dayjs(selectedDates[0]), dayjs(selectedDates[1])]
                  : null
              }
              format="YYYY-MM-DD"
              style={{ width: 350 }}
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
            />
          </div>
          <div style={{ alignSelf: "flex-end" }}>
            <Button
              type="primary"
              className="save_btn"
              style={{ color: "white", marginBottom: "13px" }}
              onClick={() =>
                DOWNLOADPDF(
                  decklogdownloadPdfUrl,
                  voyage_ids,
                  startDate,
                  endDate
                )
              }
            >
              Download Pdf
            </Button>
          </div>
        </div>
      </div>

      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
        rowKey="id"
        loading={page_loader}
        className="custom-table"
      />
    </>
  );
};

export default NotificationList;
